module.exports = {
	Clipboard: require("./Clipboard").default,
	ClipboardFormats: require("./ClipboardFormats").default,
	ClipboardTransferMode: require("./ClipboardTransferMode").default
}